var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bg-white",attrs:{"id":"empty-box"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('span',[_vm._v(_vm._s(this.message))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }